import { __assign, __spreadArrays } from "tslib";
import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { config } from '../../../config';
import Add from 'wix-ui-icons-common/Add';
import Confirm from 'wix-ui-icons-common/Confirm';
import s from './selector-button.scss';
import { biLogger } from '../../../bi';
import { Button } from 'wix-style-react';
import { AppMarketLink } from '../../app-market-link';
import { Path } from '../../../enums/marketplace-enums';
import { toJS } from 'mobx';
var subCatLinkUrl = function (categorySlug, slug, route) {
    if (slug === 'all') {
        return Path.CATEGORY + "/" + categorySlug;
    }
    var selectedSubCategories = route.subCategories
        ? toJS(route.subCategories)
        : [];
    var isSelected = selectedSubCategories.findIndex(function (selected) { return selected === slug; }) > -1;
    var newSubCategories = isSelected
        ? selectedSubCategories.filter(function (subSlug) { return subSlug !== slug; })
        : __spreadArrays(selectedSubCategories, [slug]);
    if (newSubCategories.length > 0) {
        return Path.CATEGORY + "/" + categorySlug + "/" + newSubCategories
            .sort()
            .join('__');
    }
    return Path.CATEGORY + "/" + categorySlug;
};
export var SelectorButton = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var name = _a.name, slug = _a.slug, categoryName = _a.categoryName, marketplaceStore = _a.marketplaceStore, subCategoriesCount = _a.subCategoriesCount, categorySlug = _a.categorySlug, isSelected = _a.isSelected;
    return (React.createElement(AppMarketLink, { to: subCatLinkUrl(categorySlug, slug, marketplaceStore.route), className: s.btnLink },
        React.createElement(Button, { className: s.selectorButton, size: 'tiny', skin: 'light', prefixIcon: isSelected ||
                wasButtonSelected(slug, marketplaceStore.route, subCategoriesCount) ? (React.createElement(Confirm, null)) : (React.createElement(Add, null)), priority: wasButtonSelected(slug, marketplaceStore.route, subCategoriesCount)
                ? 'primary'
                : 'secondary', onClick: createOnClickFunction(slug, name, categoryName, marketplaceStore, subCategoriesCount), dataHook: slug + "-selector" }, name)));
});
var wasButtonSelected = function (slug, route, subCategoriesCount) {
    var subCategories = route.subCategories || [];
    return slug === 'all'
        ? subCategories.length === 0 || subCategories.length === subCategoriesCount
        : subCategories.includes(slug) &&
            subCategories.length !== subCategoriesCount;
};
var createOnClickFunction = function (slug, name, categoryName, marketplaceStore, subCategoriesCount) {
    var subCategories = marketplaceStore.route.subCategories || [];
    if (slug === 'all') {
        subCategories = undefined;
    }
    else {
        var selectedAllSubCategories = !subCategories.includes(slug) &&
            subCategories.length + 1 === subCategoriesCount;
        if (selectedAllSubCategories) {
            subCategories = undefined;
        }
        else {
            subCategories = wasButtonSelected(slug, marketplaceStore.route, subCategoriesCount)
                ? subCategories.filter(function (subCategory) { return subCategory !== slug; })
                : __spreadArrays(subCategories, [slug]);
            subCategories = subCategories.length ? subCategories : undefined;
        }
    }
    return function () {
        sendSubCategoryClickBi(slug, name, categoryName, marketplaceStore, subCategoriesCount);
        marketplaceStore.setRoute(__assign(__assign({}, marketplaceStore.route), { subCategories: subCategories }));
        config.goto(__assign(__assign({}, marketplaceStore.route), { subCategories: subCategories }));
    };
};
var sendSubCategoryClickBi = function (slug, name, categoryName, marketplaceStore, subCategoriesCount) {
    var clickedToIncludeSubCategory = slug === 'all'
        ? true
        : !wasButtonSelected(slug, marketplaceStore.route, subCategoriesCount);
    biLogger.appMarketSubCategoryClick({
        type: clickedToIncludeSubCategory ? 'include' : 'exclude',
        subcategory_name: slug.toLowerCase().replace(/-/g, '_'),
        category_name: categoryName.toLowerCase(),
        msid: marketplaceStore.metaSiteId,
    });
};
//# sourceMappingURL=selector-button.js.map